module.exports = __webpack_public_path__ + "static/media/raoul.08138595.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raoul.jpg
// module id = 547
// module chunks = 0